import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6';
import * as actions from './actions';
import {
  getOrgIppConfigs,
  createOrgIppConfig,
  updateOrgIppConfig,
  deleteOrgIppConfig,
} from '../../../lib/orgRequests.es6';
import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';

function extractError(e) {
  if (e.response && e.response.data) { return e.response.data; }
  return 'An unexpected error occurred';
}

export function* getOrgIppConfigsRequestWatcher() {
  for (;;) {
    var request = yield take(types.GET_ORG_IPP_CONFIGS_REQUEST);
    try {
      var response = yield call(getOrgIppConfigs, request.payload);
      yield put(actions.getOrgIppConfigsSuccess(response.data));
    } catch (e) {
      yield put(actions.getOrgIppConfigsFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* createOrgIppConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.CREATE_ORG_IPP_CONFIG_REQUEST);
    try {
      var response = yield call(createOrgIppConfig, request.payload);
      yield put(actions.createOrgIppConfigSuccess(response.data));
      yield put(actions.getOrgIppConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.createOrgIppConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* updateOrgIppConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.UPDATE_ORG_IPP_CONFIG_REQUEST);
    try {
      var response = yield call(updateOrgIppConfig, request.payload.guid, request.payload);
      yield put(actions.updateOrgIppConfigSuccess(response.data));
      yield put(actions.getOrgIppConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.updateOrgIppConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}

export function* deleteOrgIppConfigRequestWatcher() {
  for (;;) {
    var request = yield take(types.DELETE_ORG_IPP_CONFIG_REQUEST);
    try {
      yield call(deleteOrgIppConfig, request.payload.guid);
      yield put(actions.deleteOrgIppConfigSuccess(request.payload.guid));
      yield put(actions.getOrgIppConfigsRequest(request.payload.organization_guid));
    } catch (e) {
      yield put(actions.deleteOrgIppConfigFailure(extractError(e)));
      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}
